import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import isTouchDevice from '../../../lib/isTouchDevice';
import Popover from '../Popover';
import { BASE_CLASSES, DELAY_MS, MOUSE_LEAVE } from './constants';
import './index.scss';

const { POSITIONS, TRIGGERS } = Popover;

const Tooltip = ({
    className, // eslint-disable-line react/prop-types
    content, // eslint-disable-line react/prop-types
    delay,
    ...rest
}) => {
    const togglerWillOpen = (e) => new Promise((resolve) => {
        if (!delay || !e.target) {
            resolve();
            return;
        }

        const trigger = e.target;

        const openDelayTimeout = setTimeout(resolve, DELAY_MS);

        trigger.addEventListener(MOUSE_LEAVE, function onMouseLeave() {
            clearTimeout(openDelayTimeout);
            trigger.removeEventListener(MOUSE_LEAVE, onMouseLeave);
        }, { once: true });
    });

    const classes = cn(
        BASE_CLASSES,
        className
    );
    const trigger = isTouchDevice ? TRIGGERS.TOUCH : TRIGGERS.HOVER;

    return (
        <Popover className={classes}
            key={delay.toString()}
            willOpen={togglerWillOpen}
            content={content}
            trigger={trigger}
            position={POSITIONS.TOP}
            {...rest}/>
    );
};

Tooltip.propTypes = {
    /**
     * Delays the tooltip for a second before opening.
     */
    delay: PropTypes.bool
};

Tooltip.defaultProps = {
    delay: false
};

Object.assign(Tooltip.propTypes, Popover.propTypes); // Hack to support Storybook's prop table.
Object.assign(Tooltip, {
    POSITIONS
});

export default Tooltip;
